<template>
  <v-col align="center">
    <v-card width="850">
      <v-card-title style="font-weight: bold; font-size: 1.60em; margin-bottom: 3px">
        Security authentication
      </v-card-title>
      <v-card-text>
        <v-row class="px-3">
          <div style="text-align: start">
            HawkSoft has sent a security authentication code to<span v-if="!emailExists"> the agency main contact</span><span v-else class="font-weight-bold"> {{ registration.email }}</span>
          </div>
        </v-row>
        <v-row class="pa-3">
          If you do not receive this email within the next 10 minutes, please call HawkSoft Product Support at the number listed below.
        </v-row>
        <v-row class="px-3">
          Paste the security authentication code into the field below.
        </v-row>
        <v-row class="pa-3">
          <v-col cols="3"></v-col>
          <v-col cols="3">
            <v-text-field v-model="authCode" label="Enter Code Here" placeholder="Enter Auth Code" :error="authCodeError" :error-messages="authCodeErrorMessage"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn :disabled="resendDisabled" @click="resendCode()"><v-icon>mdi-refresh</v-icon> Resend Code</v-btn>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
        <v-row class="px-3">
          <v-col cols="2"></v-col>
          <v-col>
            <v-checkbox v-model="agreedToTerms" :error="!agreedToTerms" :error-messages="termsAndConditionsErrorMessage">
              <template slot="label">
                <span>I agree to the <a href="https://www.hawksoft.com/terms/hawksoft-marketplace/" target="_blank" @click.stop>Terms and Conditions for HawkSoft Marketplace</a>.</span>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center">
          <v-col>
            <v-btn large color="warning" :disabled="disableSubmit" @click="confirmCode()">Submit</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RegistrationConfirmation',
  data () {
    return {
      authCodeError: false,
      authCodeErrorMessage: '',
      agreedToTerms: false,
      authCode: '',
      loading: false,
      resendDisabled: false
    };
  },
  computed: {
    ...mapState(['registration']),
    emailExists () {
      return ((this.registration.email || null) !== null) && this.registration.email !== '';
    },
    disableSubmit () {
      return this.loading || this.authCode === '' || !this.agreedToTerms;
    },
    termsAndConditionsErrorMessage () {
      return this.agreedToTerms ? '' : 'You must agree to the Terms and Conditions in order to use HawkSoft Marketplace.';
    }
  },
  methods: {
    async confirmCode () {
      if ((this.authCode || null) === null || this.authCode === '') {
        this.authCodeError = true;
        this.authCodeErrorMessage = 'Please enter a code';
        return;
      }

      this.authCodeError = false;
      this.authCodeErrorMessage = '';
      this.loading = true;

      const codeConfirmResp = await this.$api.confirmAuthCode(this.authCode);

      if (codeConfirmResp.code === 0) {
        // Licensing API returns a ResponseModel
        var confirmationCodeData = JSON.parse(codeConfirmResp.data[0]);

        switch (confirmationCodeData.data[0]) {
          case 'Success':
            this.$router.push({ path: '/registration/success' });
            break;
          case 'NotFound':
            this.authCodeError = true;
            this.authCodeErrorMessage = 'Auth Code Not Found';
            break;
          case 'CodeExpired':
            this.authCodeError = true;
            this.authCodeErrorMessage = 'Auth Code Expired';
            break;
          case 'CodeInvalid':
            this.authCodeError = true;
            this.authCodeErrorMessage = 'Auth Code Invalid';
            break;
          default:
            this.authCodeError = true;
            this.authCodeErrorMessage = 'Something went wrong on our side. Please try again later.';
            break;
        }
      } else {
        this.authCodeError = true;
        this.authCodeErrorMessage = 'Something went wrong on our side. Please try again later.';
      }
      this.loading = false;
    },
    async resendCode () {
      if (this.resendDisabled) { return; }

      this.resendDisabled = true;
      var resendResponse = await this.$api.resendAuthCode();
      if (resendResponse.code !== 0) {
        this.authCodeError = true;
        this.authCodeErrorMessage = 'Something went wrong on our side resending confirmation code. Please try again later.';
      }
    }
  }
};

</script>
